<loren-card>
  @if(!isChangingPassword) {
    <button matButton="filled" class="btn-error" (click)="toggleIsChangingPassword()">
      {{ "user.change_password" | transloco }}
    </button>
  } @else {
    <loren-entity-form
      #form
      [formModel]="userChangePasswordFormModel"
      (submitForm)="handleFormSubmit($event)"
      (formFieldInteraction)="disableSubmitBtn = false">
    </loren-entity-form>

    @if(errors.length) {
      <div class="mb-3">
        @for (error of errors; track error) {
          <div class="mb-1 warn">
            {{ error }}
          </div>
        }
      </div>
    }
    <button matButton="filled"
      class="ms-2 btn-secondary"
      (click)="toggleIsChangingPassword()">
      {{ "operations.cancel" | transloco }}
    </button>
    <button
      [disabled]="disableSubmitBtn"
      matButton="filled"
      class="ms-2"
      (click)="form.onSubmit()">
      {{ "operations.save" | transloco }}
    </button>
  }
</loren-card>
